/* Ruckstuhl cleaning & care – V9.23 */
(() => {
  const normalize = (value) => (value || '')
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

  const init = (root) => {
    if (!root || root.dataset.rkCleaningReady === 'true') return;
    root.dataset.rkCleaningReady = 'true';

    const overview = root.querySelector('[data-rk-cleaning-overview]');
    const panels = [...root.querySelectorAll('[data-rk-cleaning-guide]')];
    const search = root.querySelector('[data-rk-cleaning-search]');
    const results = root.querySelector('[data-rk-cleaning-product-results]');
    const assortment = root.querySelector('[data-rk-cleaning-assortment]');
    const cards = [...root.querySelectorAll('[data-rk-cleaning-product]')];
    const status = root.querySelector('[data-rk-cleaning-search-status]');
    const min = Number(root.dataset.searchMin || 2);
    const hint = root.dataset.searchHint || '';
    const noResults = root.dataset.noResults || '';
    const resultsFound = root.dataset.resultsFound || '';

    const findPanelForHash = (hash) => {
      if (!hash) return null;
      const clean = hash.replace(/^#/, '');
      return panels.find((panel) => clean === panel.id || clean.startsWith(`${panel.id}-`)) || null;
    };

    const showOverview = ({ scroll = false } = {}) => {
      if (overview) overview.hidden = false;
      panels.forEach((panel) => { panel.hidden = true; });
      if (scroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const showGuide = (panel, hash, { scroll = true } = {}) => {
      if (!panel) return showOverview({ scroll });
      if (overview) overview.hidden = true;
      panels.forEach((item) => { item.hidden = item !== panel; });

      const targetId = (hash || '').replace(/^#/, '');
      const target = targetId ? document.getElementById(targetId) : null;
      if (target && target.tagName === 'DETAILS') target.open = true;

      requestAnimationFrame(() => {
        if (!scroll) return;
        (target || panel).scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    };

    const applyHash = ({ scroll = true } = {}) => {
      const hash = window.location.hash;
      const panel = findPanelForHash(hash);
      if (panel) showGuide(panel, hash, { scroll });
      else showOverview({ scroll: false });
    };

    root.addEventListener('click', (event) => {
      const guideLink = event.target.closest('a[href^="#guide-"]');
      if (guideLink && root.contains(guideLink)) {
        const hash = guideLink.getAttribute('href');
        const panel = findPanelForHash(hash);
        if (panel) {
          event.preventDefault();
          if (window.location.hash === hash) showGuide(panel, hash, { scroll: true });
          else window.location.hash = hash;
        }
      }

      const back = event.target.closest('[data-rk-cleaning-back]');
      if (back) {
        event.preventDefault();
        history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
        showOverview({ scroll: true });
      }
    });

    const runSearch = () => {
      if (!results) return;
      const query = normalize(search ? search.value : '');
      const showAll = Boolean(assortment && assortment.open && query.length < min);
      let visible = 0;

      if (query.length < min && !showAll) {
        cards.forEach((card) => { card.hidden = true; });
        results.hidden = true;
        if (status) status.textContent = hint;
        return;
      }

      cards.forEach((card) => {
        const matches = showAll || normalize(card.dataset.search).includes(query);
        const show = matches && (showAll || visible < 16);
        card.hidden = !show;
        if (show) visible += 1;
      });

      results.hidden = visible === 0;
      if (status) {
        if (visible === 0) status.textContent = noResults;
        else if (showAll) status.textContent = resultsFound ? resultsFound.replace('[count]', String(visible)) : String(visible);
        else status.textContent = resultsFound ? resultsFound.replace('[count]', String(visible)) : String(visible);
      }
    };

    if (search) {
      search.addEventListener('input', () => { if (assortment && normalize(search.value).length >= min) assortment.open = true; runSearch(); });
      search.addEventListener('search', runSearch);
    }
    if (assortment) assortment.addEventListener('toggle', runSearch);

    window.addEventListener('hashchange', () => applyHash({ scroll: true }));
    applyHash({ scroll: Boolean(window.location.hash) });
  };

  const initAll = () => document.querySelectorAll('[data-rk-cleaning-care]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
